import axios from "axios";
import { getLocale } from "@/plugins/i18n.js";

export default {
  getJsonToken(code) {
    return axios.get("/oauth/v2/token", {
      params: {
        client_id: "1_5rbhrb0iiukokcwk8gow0w4ocgww0oco8g8gsgokwc0wcssg4w",
        client_secret: "2rlxzhijcx448ow4c0gksw4wo8oo4k8kkwwg0osskk8g0k8kw8",
        grant_type: "http://sso",
        code: code,
      },
    });
  },
  getToken(username, password) {
    return new Promise((resolve, reject) => {
      axios
        .get("/oauth/v2/token", {
          params: {
            client_id: "1_5rbhrb0iiukokcwk8gow0w4ocgww0oco8g8gsgokwc0wcssg4w",
            client_secret: "2rlxzhijcx448ow4c0gksw4wo8oo4k8kkwwg0osskk8g0k8kw8",
            grant_type: "http://aqualeha",
            username: username,
            password: password,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch(() => {
          reject();
        });
    });
  },

  refreshToken(refreshToken) {
    return new Promise((resolve, reject) => {
      axios
        .get("/oauth/v2/token", {
          params: {
            client_id: "1_5rbhrb0iiukokcwk8gow0w4ocgww0oco8g8gsgokwc0wcssg4w",
            client_secret: "2rlxzhijcx448ow4c0gksw4wo8oo4k8kkwwg0osskk8g0k8kw8",
            grant_type: "refresh_token",
            refresh_token: refreshToken,
          },
        })
        .then((response) => {
          resolve(response);
        })
        .catch(() => {
          reject();
        });
    });
  },
  getInfosUser(locale = null) {
    return axios.get(`/api/${getLocale(locale)}/customer`);
  },
  setDomicile(domicile, locale = null) {
    return axios.patch(`api/${getLocale(locale)}/customer/domicile`, {
      domicile: domicile.id,
    });
  },

  /**
   * @param {'info'|'crit'} type
   * @param {string} locale
   */
  countNotification(type, locale = null) {
    return axios.get(
      `/api/${getLocale(locale)}/customer/notification/count/${type}`
    );
  },

  /**
   * @param {'info'|'crit'} type
   * @param {string} locale
   */
  getNotification(type, locale = null) {
    return axios.get(`/api/${getLocale(locale)}/customer/notification/${type}`);
  },

  /**
   * @param {'info'|'crit'} type
   * @param {number} page
   * @param {string} locale
   */
  getNotificationPaginated(type, page = 1, locale = null) {
    return axios.get(
      `/api/${getLocale(locale)}/customer/notification/${type}/paginated`,
      {
        params: {
          page: page,
        },
      }
    );
  },

  /**
   * @param {number} notificationId
   * @param {string} locale
   */
  readNotification(notificationId, locale = null) {
    return axios.patch(
      `/api/${getLocale(locale)}/notification/${notificationId}/read`
    );
  },

  /**
   * @param {Array<number>} notificationIds
   * @param {string} locale
   */
  readNotifications(notificationIds, locale = null) {
    return axios.post(`/api/${getLocale(locale)}/notification/read`, {
      ids: notificationIds,
    });
  },

  getHolidays(year, locale = null) {
    return axios.get(`/api/${getLocale(locale)}/holidays/${year}`);
  },
};
